import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { MasterDataEndpoint, MasterDataType } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class MasterDataFileService {
  constructor(private http: WrapperHttpService) {}

  public uploadDocument(type: MasterDataType, file: File): Observable<string> {
    const formData = new FormData();
    formData.append('file', file);

    const url = `${API_URL}${MasterDataEndpoint.Base}/${type}`;
    return this.http.post<string>(url, formData);
  }

  public downloadDocument(type: MasterDataType): Observable<HttpResponse<Blob>> {
    const url = `${API_URL}${MasterDataEndpoint.Base}/${type}`;
    return this.http.get<HttpResponse<Blob>>(url, {
      responseType: 'blob',
      observe: 'response',
    });
  }
}
